import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardMedia,
  Tooltip,
  Typography,
} from '../../imports/muiImport';
import { Link } from '../../imports/generalImport';
import { capitalizeFirst, extractDiscount } from '../../hooks/utilsFn/utilsFn';
import imageNotFound from "../../assets/card-image/product-not-found.jpg"

const ProductCard = ({ customStyles, data, categories }) => {
  let discount = undefined;
  if (data?.denominations?.length > 0) {
    discount = extractDiscount(data?.denominations?.[0]);
  } else if (categories?.node?.denominations?.length > 0) {
    discount = extractDiscount(categories?.node?.denominations?.[0]);
  } else {
    discount = extractDiscount(data?.node?.denominations?.[0]);
  }
  const dicsountName = data?.denominations?.[0].cashbackOrDiscount || categories?.node?.denominations?.[0].cashbackOrDiscount || data?.node?.denominations?.[0].cashbackOrDiscount



  const Url = `/card-details/${data?.slug ?? data?.node?.slug ?? categories?.node?.slug}`;
  const logoUrl = data?.productImages?.[0]?.url ?? categories?.node?.productImages?.[0]?.url ?? data?.logoUrl;

  return (
    <Link to={Url} style={{ textDecoration: 'none' }}>
      <Box sx={customStyles}>
        <Card
          sx={{
            width: "100%",
            aspectRatio: {
              xs: "1 / 0.7",
              sm: "4 / 3",
              md: "3 / 1.9",
            },
            overflow: "hidden",
            mt: 2,
            mb: 1,
            borderRadius: '10px',
            boxShadow: 'none',
            transition: '0.3s',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
            },
          }}
        >
          {/* image section  */}
          <CardMedia
            component="img"
            image={logoUrl || data?.node?.productImages?.[0]?.url || imageNotFound}
            alt={data?.name}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 2
            }}
          />
        </Card>
<Tooltip
  title={data?.name ?? data?.node?.name ?? categories?.node?.name ?? ""}
  placement="top"
  arrow
>
  <Typography
    sx={{
      fontSize: { xs: "11px", sm: "13.5px" },
      fontWeight: 500,
      ml: 0.75,
      fontFamily: "Be Vietnam Pro",
      color: "#000000",
      textAlign: "start",
      textTransform: "capitalize",
      maxWidth: { xs: "150px", sm: "220px" },
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "block",
      cursor: "pointer",
    }}
  >
    {capitalizeFirst(
      data?.name ?? data?.node?.name ?? categories?.node?.name
    )}
  </Typography>
</Tooltip>

        {data?.denominations && (
          <Typography
            sx={{
              fontSize: { xs: "11px", sm: "13.5px" },
              fontWeight: 650,
              ml: 0.75,
              fontFamily: "Be Vietnam Pro",
              color: "#007411",
              textAlign: "start",
            }}
          >
            {discount}%{" "}
            {capitalizeFirst(dicsountName)}

          </Typography>
        )}

        {!data?.denominations && data?.node?.denominations && (
          <Typography
            sx={{
              fontSize: { xs: "11px", sm: "13.5px" },
              fontWeight: 650,
              ml: 0.75,
              fontFamily: "Be Vietnam Pro",
              color: "#007411",
              textAlign: "start",
            }}
          >
            {discount}%{" "}
            {capitalizeFirst(dicsountName)}
          </Typography>
        )}

        {!data?.denominations &&
          !data?.node?.denominations &&
          categories?.node?.denominations && (
            <Typography
              sx={{
                fontSize: { xs: "11px", sm: "13.5px" },
                fontWeight: 650,
                ml: 0.75,
                fontFamily: "Be Vietnam Pro",
                color: "#007411",
                textAlign: "start",
              }}
            >
              {discount}%{" "}
              {capitalizeFirst(dicsountName)}
            </Typography>
          )
        }
      </Box>
    </Link>
  );
};

ProductCard.propTypes = {
  customStyles: PropTypes.object,
  data: PropTypes.object,
};

export default ProductCard;
